import { loadState, saveState } from '../../../_core/localStorage';

const initialState = {
  userInfo: '',
  unreadOffers: '',
  jobOffers: ''
};

const userHome = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_INFORMATION_SUCCESS':
      // Store isConfirmed status in localStorage for route protection
      if (action.payload && typeof action.payload.isConfirmed !== 'undefined') {
        const currentState = loadState();
        saveState({
          ...currentState,
          isConfirmed: action.payload.isConfirmed
        });
      }
      
      return {
        ...state,
        userInfo: action.payload
      };
    case 'UNREAD_JOB_OFFERS_SUCCESS':
      return {
        ...state,
        unreadOffers: action.payload
      };
    default:
      return state;
  }
};

export default userHome;
